import { Box, Container } from "@mui/material";
import { PageHeader } from "@zfp-akademie-a-s/zfp-design";
import { AppBar } from "Components/_Shared/AppBar/AppBar";
import { Spacing } from "Infrastructure/Themes/Themes";
import { type ComponentProps, type FC, type PropsWithChildren, useEffect } from "react";

type Props = {
  readonly container?: boolean;
  readonly title: string;
  readonly header?: ComponentProps<typeof PageHeader>;
};

export const AuthenticatedLayout: FC<PropsWithChildren<Props>> = ({ children, title, header, container = true }) => {
  useEffect(() => {
    document.title = `${title} | Analyzátor`;
  }, [title]);

  return (
    <>
      <AppBar />
      {header && <PageHeader {...header} />}
      {container ? (
        <Container>
          <Box py={Spacing.XXXL}>{children}</Box>
        </Container>
      ) : (
        children
      )}
    </>
  );
};
